import { render, staticRenderFns } from "./messageDetail.vue?vue&type=template&id=a612c94a&scoped=true&"
import script from "./messageDetail.vue?vue&type=script&lang=js&"
export * from "./messageDetail.vue?vue&type=script&lang=js&"
import style0 from "./messageDetail.vue?vue&type=style&index=0&id=a612c94a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a612c94a",
  null
  
)

export default component.exports